@if (svc.isVisible) {
  <button
    (click)="svc.toggle()"
    aria-label="Ver alertas de plan"
    class="d-grid place-items-center sw-bell-btn nav-link"
    type="button"
  >
    <div class="sw-bell-wrapper">
      <svg cIcon name="cilBell" size="lg"></svg>
      @if (svc.hasAlerts()) {
        <span class="sw-alerts-badge">
          {{ svc.alertCount() > 9 ? '9+' : svc.alertCount() }}
        </span>
      }
    </div>
  </button>
}
